// react
import React, { /*useEffect, useState*/ } from "react";
// internal
import GetTrad from "./../../components/utils/GetTrad"
// style
import "./Header.css"

const Header = (props) => {

    return (
		<React.Fragment>
            <div
				className={"header "+(props.menuDisplay ? "header-hidden" : "")+""}
			>
                
                <div
                    className="menu-close"
                    onClick={() => props.toggleMenu()}
                    style={{
                        display: props.menuDisplay ? "block" : "none"
                    }}
                ></div>

				<div
					className="menu-logo tsv7"
					style={{
                        display: props.menuDisplay ? "block" : "none"
                    }}
				>TECH<span>4</span>PLANET</div>

                <a className="logo" href="./"></a>

                <div className="title fsrufusbold"><GetTrad id="sourceword" lang={props.lang} /></div>
                <div
					className={"navbarright "+((props.menuDisplay || props.popup) ? "" : "navbarright-menu-hidden")+" "+(props.popup ? "navbarright-menu-popup-hidden" : "")+""}
				>
                    <span
                        className={"lang lang-en tsv7 "+(props.lang === "en" ? "lang-selected" : "" +"")}
                        onClick={() => props.setLang("en")}
                    >EN</span>
                    <span 
                        className={"lang lang-fr tsv7 "+(props.lang === "fr" ? "lang-selected" : "" +"")}
                        onClick={() => props.setLang("fr")}
                    >FR</span>
                    <div
						className={"lang-separator"}
					></div>
                    <div
                        className={"menu-link "+(props.popup ? "menu-link-popup" : "")+""}
                        onClick={() => props.toggleMenu()}
                    ></div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Header;